"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsealingInstructions = void 0;
const UnsealingInstructions = (unsealingInstructionsAsObjectOrJson) => (typeof unsealingInstructionsAsObjectOrJson === "object") ?
    unsealingInstructionsAsObjectOrJson :
    JSON.parse(unsealingInstructionsAsObjectOrJson || "{}");
exports.UnsealingInstructions = UnsealingInstructions;
//# sourceMappingURL=unsealing-instructions.js.map